// removed by extract-text-webpack-plugin
module.exports = {"input-container":"input-container__1MDb1","input":"input__1FpiO","button":"button__25luL","border":"border__1SX-7"};


//////////////////
// WEBPACK FOOTER
// ./components/search/input/style.css
// module id = 5pTR
// module chunks = 14